import React, { useState } from 'react';
import styled from 'styled-components';
import ReactGA from 'react-ga4';

import { ActionButton } from '../components/Button';
import Loading from '../components/Loading';

const WaitingWrapper = styled.div`
  height: 0;
  position: relative;
  transform: translateY(10px);
`;

const Label = styled.span`
  opacity: ${p => (p.hidden ? '0' : '1')};
  transition: opacity 0.1s linear;
`;

function CreateAccountButton({
  label = 'Get started',
  type = undefined,
  location,
  onboard = '',
  plan,
}) {
  const [isWaiting, setIsWaiting] = useState(false);

  const handleButtonClick = () => {
    const currentPath = window.location.pathname;
    const isLandingPage = currentPath.includes('landing-pages');
    const onboardPreconfig = onboard;
    let registrationPage = `/create-upgrade${plan ? `?plan=${plan}` : ''}`;
    const randomNumber = Math.random();

    if (!plan && (isLandingPage || randomNumber > 0.15)) {
      registrationPage = `/start?option=${onboardPreconfig}`;
    }

    if (isWaiting) {
      return null;
    }

    setIsWaiting(true);

    ReactGA.event({
      category: 'Registration',
      action: 'Click Register CTA',
      label: location,
    });

    // Track with Mixpanel
    window?.mixpanel?.track('Click Register CTA', {
      registration_page: registrationPage,
      location: location,
    });

    // Track with Plausible Analytics
    if (window.plausible) {
      window.plausible('Click Register CTA', {
        props: {
          location: location,
          registration_page: registrationPage,
        },
      });
    }

    window.localStorage.setItem('utm_landing_cta', location);

    window.setTimeout(() => {
      window.location = registrationPage;
      setIsWaiting(false);
    }, 750);
  };

  return (
    <ActionButton onClick={handleButtonClick} buttonType={type}>
      <WaitingWrapper>
        {!isWaiting ? null : (
          <Loading color={type === 'primary' ? '#fff' : '#444'} size="medium" />
        )}
      </WaitingWrapper>
      <Label hidden={isWaiting}>{label}</Label>
    </ActionButton>
  );
}

export default CreateAccountButton;
